import * as React from 'react';

/** Diagonal paper-plane / "send" glyph — used on the "Request to play" CTA. */
export default function PaperPlane({ className, viewBox }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      viewBox={viewBox || '0 0 20 20'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7139 6.3749C18.9568 6.08429 19.0147 5.68137 18.8634 5.33412C18.7121 4.98688 18.3776 4.75491 17.9994 4.73494L2.36867 3.9096C1.97266 3.88869 1.6017 4.10377 1.4231 4.45784C1.2445 4.81192 1.292 5.23807 1.54418 5.54413L4.85098 9.55733C5.13491 9.9019 5.61286 10.0165 6.02217 9.83817L10.2131 8.01221C10.7194 7.79161 11.3087 8.02323 11.5293 8.52955C11.7499 9.03586 11.5183 9.62514 11.012 9.84574L6.82104 11.6717C6.41172 11.85 6.17022 12.2781 6.22924 12.7207L6.91673 17.8751C6.96916 18.2682 7.24892 18.5932 7.62984 18.7035C8.01076 18.8137 8.42086 18.6885 8.6752 18.3843L18.7139 6.3749Z"
        fill="currentColor"
      />
    </svg>
  );
}
